interface PromiseRetryArgs {
  promiseFn: () => Promise<unknown>
  count?: number
  interval?: number
  retryMessage?: string
}

export const promiseRetry = ({
  promiseFn,
  count = 3,
  interval = 500,
  retryMessage = 'Failed to resolve promise, retrying...',
}: PromiseRetryArgs) => {
  let retryCount = count
  return new Promise((resolve, reject) => {
    const retry = () => promiseFn()
      .then(resolve)
      .catch((error) => {
        console.warn(retryMessage)
        if (retryCount <= 0) {
          return reject(new Error(`Failed to resolve promise after ${count} attempts: ${error.message}`))
        }
        retryCount--
        setTimeout(retry, interval)
      })
    retry()
  })
}
